<template>
    <v-tooltip top class="tooltip-botao-baixar-todos">
      <a slot="activator" :class="`solicitar-novo-documento ${colorClass} ${desabilitar ?  'desabilitado' : 'habilitado'}`" @click="$emit('solicitarNovoDocumento')">
        <span class="ml-1">{{ texto }}</span>
      </a>
      {{ desabilitar ? 'É preciso estar em modo de edição para solicitar documento' : 'Solicitar novo documento ao fornecedor.' }}
    </v-tooltip>
</template>

<script>
export default {
    name: 'BotaoSolicitarNovoDocumento',
    props:{
        texto:{
            type: String,
            default: 'Solicitar Documento'
        },
        colorClass:{
            type: String,
            default: 'secondary-color'
        },
      desabilitar: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style scoped lang="stylus">
    a.solicitar-novo-documento *
        background-color transparent

    a.solicitar-novo-documento
        margin-left 10px
        min-width 50px
        font-size 13px
        display block

    a.desabilitado
        pointer-events none
        opacity 0.5

    .secondary-color
        color #FF9800 !important

    i
        font-size 13px
        top 0

</style>
